import napStyles from './napRtl.json'
import mediaQuery from './mediaQuery'
import * as theme from './nap/index'
import * as themeRtl from './napRtl/index';
import motionSpecs from './motionSpecs'

export default {
  direction: 'rtl',
  typography: napStyles,
  baseOverrides: theme.baseOverrides,
  breakpoints: theme.breakpoints,
  spacingMultiplier: 8,
  rowOffsetTopSmall: 3,
  rowOffsetTopMedium: 4,
  rowOffsetTopLarge: 6,
  rowOffsetTopXLarge: 6,
  fullBleed: true,
  mediaQuery,
  motionSpecs,
  custom: {
    ...theme,
    ...themeRtl
  }
}
